<div class="table-responsive">
  <table class="table table-striped">
    <!--<caption>
    <input id="select_all" [(ngModel)]="isAllChecked" (change)="selectAllCheckBox($event);" class="css-checkbox select-all" type="checkbox">
    <label for="select_all" class="css-label">Select All</label>
  </caption>-->
  <thead class="thead-dark">
    <tr>
      @for (field of pageFields; track field) {
        @if (field.isSystemRefId === 1;) {
          <th class="small"></th>
        }
        @if (field.isSystemRefId === 0;) {
          @if (inputParams.isSortEnabled) {
            <th (click)="SortData(field.columnName, field.isSortable)" [ngClass]="[field.isSortable === 1 ? 'sort SORTASC' : '']">
              <span>{{ field.columnHeader }}</span>
              <span class="sort">
                <i [ngClass]="[field.columnName === inputParams.sortColumn && inputParams.isAscendingSort ? 'fa fa-long-arrow-up' : field.columnName === inputParams.sortColumn && !inputParams.isAscendingSort ? 'fa fa-long-arrow-down' : '']"></i>
              </span>
            </th>
          }
          @if (!inputParams.isSortEnabled) {
            <th>
              <span>{{ field.columnHeader }}</span>
            </th>
          }
        }
      }
      @for (key of inputParams.customfieldTranslationKeys; track key) {
        <th>{{ key | translate}}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (data of listOfData; track data) {
      <tr class="List-Row alterColor">
        @for (field of pageFields; track field) {
          @for (propertyName of properties; track propertyName) {
            @if (field.columnName.toLowerCase() === propertyName.toLowerCase();) {
              @if (field.isSystemRefId === 1;) {
                <td class="small">
                  @if (isSingleSelection) {
                    <input type="radio" name="radiogroup_{{RefId}}" [value]="data[RefId]" (change)="toggleRadioButton(data)">
                  }
                  @if (isMultipleSelection) {
                    <input type="checkbox" class="css-checkbox checkbox-user" (click)="toggleCheckBox(data, data.checked)" [(ngModel)]="data.checked" id="checkbox_{{data[RefId]}}" value="{{data[RefId]}}">
                    <label for="checkbox_{{data[RefId]}}" class="css-label"></label>
                  }
                </td>
              }
              @if (field.isSystemRefId === 0 && field.columnName.search('HtmlLink') === -1) {
                <td [innerHTML]='[field.columnType === "DATE" ? (data[propertyName] | date : "dd/MM/yyyy") : data[propertyName]]'></td>
              }
              @if (field.isSystemRefId === 0 && field.columnName.search('HtmlLink') !== -1) {
                <td clickStopPropagation [innerHTML]='[field.columnType === "DATE" ? (data[propertyName] | date : "dd/MM/yyyy") : data[propertyName]] '></td>
              }
            }
          }
        }
        @for (value of inputParams.customfieldValues; track value) {
          <td clickStopPropagation (click)="OnClick(value.fieldData, data[RefId], data)">@if (!value.isIcon) {
            <b>{{ value.translationKey | translate}}</b>
            }@if (value.isIcon) {
            <i [ngClass]="value.iconClass"></i>
          }</td>
        }
      </tr>
    }
  </tbody>
</table>

<hr />
<div class="pager">
  <ul class="pagination">
    <li><strong><span>Showing Records<span>:</span></span></strong> {{showingRecordStart}} - {{showingRecordEnd}} of {{totalRows}}</li>
  </ul>

  <ul class="pagination">
    <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(1)"><i class="fa fa-angle-double-left"></i></a></li>
    <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(pageNo-1)"><i class="fa fa-angle-left"></i></a></li>
    <li><span>Page {{pageNo}} of {{totalPages}}</span></li>
    <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(pageNo+1)"><i class="fa fa-angle-right"></i></a></li>
    <li class="highlight"><a href="javascript:void(0);" (click)="switchPage(totalPages)"><i class="fa fa-angle-double-right"></i></a></li>
    <li class="pagedropdown">
      <span class="goto">
        <span>Move To Page</span>:
        <select id="cmbpageno" (change)="selectPage($event);" [(ngModel)]="pageNo">
          @for (p of getTotalPagesList(); track p) {
            <option [value]="p">{{p}}</option>
          }
        </select>
      </span>
    </li>
  </ul>
</div>
</div>
